import { FormGroup } from '@angular/forms';

export const markAllAsTouched = (
  formGroup: FormGroup,
  markNonControlAccessorFields = false
): void => {
  //Mark any inputs with class 'touch-status' as touched

  if (markNonControlAccessorFields) {
    const inputs = document.querySelectorAll('input.touch-status');
    inputs.forEach((input: Element) => {
      (input as HTMLInputElement).value = 'true';
    });
  }

  (Object as any).values(formGroup.controls).forEach((control: any) => {
    control.markAsTouched();
    if (control.controls) {
      markAllAsTouched(control);
    }
  });
};
